module.exports = __webpack_public_path__ + "img/9791158882716.fd47bfd0.jpg";